"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _ = require("../..");

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var useStyles = (0, _core.makeStyles)(_styles.default, {
  name: 'Code'
});
var BACKSPACE_KEY = 8;
var LEFT_ARROW_KEY = 37;
var RIGHT_ARROW_KEY = 39;

var isNumber = function isNumber(string) {
  return /^\d+$/.test(string);
};

var Code = function Code(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 4 : _ref$size,
      _ref$onChange = _ref.onChange,
      onChange = _ref$onChange === void 0 ? function () {} : _ref$onChange,
      rest = _objectWithoutProperties(_ref, ["size", "onChange"]);

  var classes = useStyles();

  var refs = _react.default.useRef([]);

  var _React$useState = _react.default.useState(Array(size).fill('')),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      values = _React$useState2[0],
      setValues = _React$useState2[1];

  var focusInput = function focusInput(index) {
    var input = refs.current[index];

    if (!input) {
      return;
    }

    input.focus();
    input.select();
  };

  var focusPrevInput = function focusPrevInput(currentIndex) {
    focusInput(currentIndex - 1);
  };

  var focusNextInput = function focusNextInput(currentIndex) {
    focusInput(currentIndex + 1);
  };

  var focusLastInput = function focusLastInput() {
    focusInput(size - 1);
  };

  var handleKeyUp = function handleKeyUp(event, index) {
    var newValues = _toConsumableArray(values);

    if (event.keyCode === LEFT_ARROW_KEY) {
      focusPrevInput(index);
      return;
    }

    if (event.keyCode === RIGHT_ARROW_KEY) {
      focusNextInput(index);
    }

    if (event.keyCode === BACKSPACE_KEY) {
      if (!values[index]) {
        focusPrevInput(index);
      }

      newValues[index] = '';
      setValues(newValues);
      onChange(newValues.join(''));
      return;
    }

    if (isNumber(event.key)) {
      newValues[index] = event.key;
      setValues(newValues);
      onChange(newValues.join(''));
      focusNextInput(index);
    }
  };

  var handleChange = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(event, index) {
      var isFirstInput, value, textLengthEqualsToSize;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              isFirstInput = index === 0;

              if (isFirstInput) {
                _context.next = 4;
                break;
              }

              return _context.abrupt("return");

            case 4:
              value = event.target.value;
              textLengthEqualsToSize = value.length === size;

              if (isNumber(value) && isFirstInput && textLengthEqualsToSize) {
                setValues(value.split(''));
                onChange(value);
                focusLastInput();
              }

              _context.next = 11;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function handleChange(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react.default.createElement("div", {
    className: classes.root
  }, values.map(function (value, index) {
    return /*#__PURE__*/_react.default.createElement(_.Form.TextField, {
      name: "input".concat(index),
      value: value,
      className: classes.input,
      inputRef: function inputRef(ref) {
        refs.current[index] = ref;
      },
      inputProps: _objectSpread({
        className: classes.inputElement
      }, index === 0 ? {} : {
        maxLength: 1
      }),
      type: "tel",
      onKeyUp: function onKeyUp(event) {
        return handleKeyUp(event, index);
      },
      onChange: function onChange(event) {
        return handleChange(event, index);
      },
      key: "input".concat(index)
    });
  }));
};

var _default = Code;
exports.default = _default;